/**
 * =============================================================================
 * ListPageFooter — Rodapé fixo (paginação) padrão.
 *
 * Aplica `px-4 pb-4` em torno do conteúdo (geralmente <PaginationFooter />).
 *
 * @version 1.0.0
 * RELEASE: 2026-04-25 v1.0.0 - Criação do helper de footer padronizado.
 * =============================================================================
 */
import React from 'react';
import { cn } from '@/lib/utils';

interface ListPageFooterProps {
  children: React.ReactNode;
  className?: string;
}

export function ListPageFooter({ children, className }: ListPageFooterProps) {
  return <div className={cn('px-4 pb-4', className)}>{children}</div>;
}
